import React from 'react'
import ReactMarkdown from 'react-markdown'
import styles from './styles.css'

interface Question {
  question: string
  answer: string
}

interface Props {
  questions: Question[]
}

const FAQQuestions: React.SFC<Props> = ({ questions }) => (
  <div className={styles.content}>
    {questions.map(({ question, answer }, index) => (
      <div key={`${question}-${index}`} className={styles.questionContainer}>
        <div className={styles.questionTitle}>{question}</div>
        <ReactMarkdown source={answer} className={styles.questionBody} />
      </div>
    ))}
  </div>
)

export default FAQQuestions
